"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = void 0;

var styled_components_1 = require("styled-components");

var styled_system_1 = require("styled-system");

var transition = styled_system_1.system({
  transition: true
});
exports.Block = styled_components_1.default.div(styled_system_1.compose(styled_system_1.space, styled_system_1.color, styled_system_1.layout, styled_system_1.flexbox, styled_system_1.background, styled_system_1.border, styled_system_1.position, transition));